import React from 'react'
import classNames from 'classnames'

import { StateProvider, getHTML } from '../../core'
import MediaWithContent from '../MediaWithContent'
import Content from '../../content'

import './press.scss'

class PressSection extends React.Component {
  render() {
    const data = this.props.data || {}
    const context = this.props.context || {}

    const { 
      content,
      button,
      logos,
    } = data

    return (
      <section styleName="press-section">
        <MediaWithContent
          media={(
            <div styleName="logos-wrapper">
              <div styleName="logos">
                {(logos || []).map((logo, i) => {
                  if (!logo) {
                    return null
                  }
        
                  return (
                    <div 
                      styleName="logo" 
                      key={i}
                      style={{ backgroundImage: `url(${logo.resize.src})`}}
                    />
                  )
                })}
              </div>
            </div>
          )}
          content={(
            <div styleName='content-wrapper'>
              {content[0].static 
                || <Content 
                  typename={content[0].__typename} 
                  id={content[0].id} 
                  context={context}
                />}
            </div>
          )}
          mediaLeftDesktop={false}
          contentTheme='Dark'
          isStatic={true}
        />

        <a styleName='button-wrapper' href={button.link}>
          <button>
            {button.text}
          </button>
        </a>
      </section>
    )
  }
}

export default PressSection